import { z } from 'zod';
export const ProviderSchema = z.enum(['huggingface', 'civitai', 'comfyorg', 'anthropic']);
export const ProviderTokenStatusSchema = z.object({
    provider: ProviderSchema,
    set: z.boolean(),
    updatedAt: z.string().nullable(),
});
export const ProviderTokensResponseSchema = z.object({ tokens: z.array(ProviderTokenStatusSchema) });
/** Write-only: the server never sends a token back. */
export const SetProviderTokenRequestSchema = z.object({
    token: z.string().trim().min(8, 'At least 8 characters').max(512).regex(/^[\x21-\x7e]+$/, 'No spaces or special characters'),
});
//# sourceMappingURL=tokens.js.map